import {booleanAttribute, Component, input} from '@angular/core';
import {PagedList} from '../../../models/entity.model';
import {AsyncPipe} from '@angular/common';
import {Observable, of} from 'rxjs';
import {SpinnerComponent} from '../../spinner/spinner.component';
import {EntityCardComponent} from '../entity-card/entity-card.component';
import {NamedEntityModel} from "../../../models/named-entity.model";

@Component({
  selector: 'app-entity-list',
  imports: [
    AsyncPipe,
    SpinnerComponent,
    EntityCardComponent
  ],
  templateUrl: './entity-list.component.html',
  host: {
    class: 'app-column gapped tight'
  }
})
export class EntityListComponent {
  readonly paged = input<boolean, any>(false, {transform: booleanAttribute})
  readonly items = input.required<
    Observable<PagedList<NamedEntityModel<any>>>,
    Observable<PagedList<NamedEntityModel<any>>>
    | NamedEntityModel<any>[]
    | undefined
    | null
  >({
    transform: val => {
      if (val instanceof Observable) {
        return val
      } else if (Array.isArray(val)) {
        return of({ count: val.length, items: val, pages: 1, page: 1 })
      } else if (val) {
        throw new Error(`Invalid entity list value: ${JSON.stringify(val, null, 2)}`)
      } else {
        return of({ count: 0, items: [], pages: 1, page: 1 })
      }
    }
  })
  readonly linked = input<boolean, any>(false, {transform: booleanAttribute})
}
